import { GET_SYSTEM_SETTING, STOP_LOADING, EDIT_SYSTEM_SETTING, START_LOADING, ERROR, DATA_DECLERATION_PDF } from "../SystemsAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_SYSTEM_SETTING:
      return {
        ...state,
        system_settings: action.payload,
        loading: false,
        success: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case EDIT_SYSTEM_SETTING:
      return {
        ...state,
        loading: false,
        system_settings: action.payload
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    case DATA_DECLERATION_PDF:
      return {
        ...state,
        dataDeclerationPdf: action.payload,
        loading: false
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}